import React from "react";
import { Box, Text, HStack, VStack, Badge } from "@chakra-ui/react";
import wmIcon from "../images/sensor2.png";
import elevIcon from "../images/elevator_icon.png";
import { useTranslation } from "react-i18next";

export const ElevatorDevice = ({ device }) => {
    const { t } = useTranslation();

    return (
        <Box mb="40px">
            <Text fontSize="sm" m="2px">
                {device.deviceName}
            </Text>
            <Box minW="200px" borderWidth="1px" borderRadius="lg" overflow="hidden">
                <Box m="5px" display="flex" alignItems="center">
                    <img width={14} height={14} src={wmIcon} />
                    <Text ml="4px" fontSize="lg">
                        {t("text_elevator_alarm")}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[0] === "1" ? 'red' : 'green'}>
                        {device.status[0] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[1] === "1" ? 'red' : 'green'}>
                        {device.status[1] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[2] === "1" ? 'red' : 'green'}>
                        {device.status[2] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
                <Box mt="10px" mb="30px" align="center">
                    <Text fontSize="l" m="10px" color={device.status[3] === "1" ? 'red' : 'green'}>
                        {device.status[3] === "1" ? "警報" : "正常"}
                    </Text>
                </Box>
            </Box>
        </Box>

    );
};
